'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './news-show.routes';

export class NewsShowComponent {
  constructor($stateParams, NewsService, Auth, dialogs, $state) {
    'ngInject';
    this.newsId = $stateParams.id;
    this.isAdmin = Auth.isAdminSync;
    this.dialogs = dialogs;
    this.$state = $state;

    this.NewsService = NewsService;

    this.NewsService.get({id: this.newsId}, news => {
      this.news = news;
      this.news.body = this.convertShortcode(this.news.body);
    }, err => {
      console.log('Could not get the news from the server.');
    });
  }

  convertShortcode(html) {
    return html.replace(/\[/g,"<").replace(/\]/g,">");
  }

  delete() {
    var that = this;

    var dlg = this.dialogs.confirm("Delete News Post?", "Do you really want to delete this news post?");
    dlg.result.then(() => {
      // OK delete it
      that.NewsService.delete({id: that.newsId},
        () => {
          that.$state.go(that.type+"-news-list");
        },
        err => {
          alert("Could not delete news post");
        });
    }, () => {
      // Cancel
    });
  }
}

export default angular.module('conduuApp.newsShow', [uiRouter])
  .config(routes)
  .component('newsShow', {
    template: require('./news-show.html'),
    controller: NewsShowComponent,
    controllerAs: 'ctrl',
    bindings: {
      type: '@'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/news/show/news-show.component.js